import { ENDPOINTS } from 'config/endpoints';
import { useMutation } from '@tanstack/react-query';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import CronoError from 'crono-fe-common/types/error';
import IntegrationType from 'crono-fe-common/types/enums/integrationType';
import { getLabelForIntegrationType } from 'crono-fe-common/utils/crm-utils';

export type SalesforceOauthCode = {
  code: string;
  codeVerifier?: string;
};

const integrationLabel = getLabelForIntegrationType(IntegrationType.SALESFORCE);

const salesforceAuthCallback = (data: SalesforceOauthCode) => {
  const request: Request = {
    url: ENDPOINTS.salesforce.authCallback,
    config: {
      method: 'post',
      data: data,
    },
  };

  return client(request);
};

const useSalesforceAuthCallback = () =>
  useMutation<Response<null>, CronoError, SalesforceOauthCode>(
    salesforceAuthCallback,
    {
      meta: {
        successMessage: `Successfully logged into ${integrationLabel}`,
        errorMessage: 'Error while connecting with the CRM',
      },
    },
  );

export default useSalesforceAuthCallback;
